import React, { useEffect } from "react";
import "../CSS/Popup.css";
import { IoCloseCircleSharp } from "react-icons/io5";
import { IoCheckmarkDoneCircle } from "react-icons/io5";

const ThankYouPopup = ({ message, onClose }) => {
  // Auto-close after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    // Cleanup timer if component unmounts
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <>
      <div className="popup_overlay" onClick={onClose}>
        <div className="popup_content" onClick={(e) => e.stopPropagation()}>
          <button className="close_btn" onClick={onClose}>
            <IoCloseCircleSharp className="close_icon"/>
          </button>
          <div className="popup_icon_wrapper">
            <IoCheckmarkDoneCircle className="check_icon" />
          </div>
          <h3 className="popup_title">Success!</h3>
          <p className="popup_message">{message}</p>
          <div className="progress_bar">
            <div className="progress_fill"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThankYouPopup;
